import React, { useEffect, useState } from 'react'
import { getGlobalState, useGlobalState } from '../../store'
import dayjs from 'dayjs'
import { setRemoteCall } from '../../remote'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  Button,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Input,
  InputGroup,
  InputLeftAddon
} from '@chakra-ui/core'
import { Text } from '@chakra-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import Timeline from '@material-ui/lab/Timeline'
import TimelineItem from '@material-ui/lab/TimelineItem'
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import Paper from '@material-ui/core/Paper'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
const useStyles = makeStyles(theme => ({
  paper: {
    padding: '6px 16px'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}))

export default function CustomizedTimeline(props) {
  const [deleteId, setDeleteId] = useState(null)
  const [formValues, setFormValues] = useState({})
  const projects = getGlobalState('projects')
  const users = getGlobalState('users')
  const resources = getGlobalState('resources')
  const [userHistory] = useGlobalState('userHistory')
  // const [userHistory, setUserHistory] = useGlobalState('userHistory')
  const [projectHistory] = useGlobalState('projectHistory')
  // const [projectHistory, setProjectHistory] = useGlobalState('projectHistory')
  const [resourceHistory] = useGlobalState('resourceHistory')
  // const [resourceHistory, setResourceHistory] = useGlobalState(
  //   'resourceHistory'
  // )

  const classes = useStyles()
  let data = []
  let type = props.type

  /**
   * get the history
   */
  useEffect(() => {
    if (type === 'user') {
      setRemoteCall('getUserHistory', props.id)
    } else if (type === 'project') {
      setRemoteCall('getProjectHistory', props.id)
    } else if (type === 'resource') {
      setRemoteCall('getResourceHistory', props.id)
    }
    // Run! Like go get some data from an API.
  }, [])

  const updateHistory = id => {
    try {
      const values = formValues[id]
      if (values) {
        console.log('Updating history', id, values.startDate, values.endDate)
        // Here you can make your API call with the form values
        setRemoteCall(
          'updateRelationDatesForId',
          {
            id,
            startDate: values.startDate,
            endDate: values.endDate
          },
          'Datas atualizadas'
        )
      }
    } catch (e) {
      console.error('Error updating history:', e)
    }
  }

  //lets find the correct displya data type
  if (type === 'user') {
    data = userHistory
  } else if (type === 'project') {
    data = projectHistory
  } else if (type === 'resource') {
    data = resourceHistory
  }

  // Initialize form values when data changes
  useEffect(() => {
    if (data && data.length > 0) {
      const initialValues = {}
      data.forEach(item => {
        initialValues[item._id] = {
          startDate: dayjs(item.startDate).format('YYYY-MM-DD'),
          endDate: dayjs(item.endDate).format('YYYY-MM-DD')
        }
      })
      setFormValues(initialValues)
    }
  }, [data])

  // Handle input changes
  const handleInputChange = (itemId, field, value) => {
    setFormValues(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [field]: value
      }
    }))
  }

  return (
    <Timeline align="alternate">
      {data &&
        data
          .sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
          .map((d, i) => {
            let thisTitle = ''

            if (type === 'user') {
              const thisElement = projects.find(p =>
                d.projectId.includes(p._id)
              )
              thisTitle = thisElement && thisElement.name
            } else if (type === 'resource') {
              const thisElement = projects.find(p =>
                d.projectId.includes(p._id)
              )
              thisTitle = thisElement && thisElement.name
            } else if (type === 'project') {
              if (d.accountId && d.accountId.length > 0) {
                const thisElement = users.find(p => d.accountId.includes(p._id))
                thisTitle = thisElement
                  ? `${thisElement.firstName} ${thisElement.lastName}`
                  : ''
              }
              if (d.resourceId && d.resourceId.length > 0) {
                const thisElement = resources.find(p =>
                  d.resourceId.includes(p._id)
                )
                thisTitle = thisElement && thisElement.name
              }
            }

            return (
              <TimelineItem key={i} style={{ marginBottom: '3em' }}>
                <TimelineOppositeContent style={{ justifyContent: 'flex-end' }}>
                  <InputGroup size={'sm'} mb={'0.5em'}>
                    <InputLeftAddon fontSize={'.8em'}>
                      <i className="icons icon-minus" />{' '}
                    </InputLeftAddon>
                    <input
                      style={{
                        fontSize: '.8em',
                        padding: '0.2em 0.5em',
                        border: '1px solid #E2E8F0'
                      }}
                      textAlign={'right'}
                      value={
                        formValues[d._id]?.endDate ||
                        dayjs(d?.endDate)?.format('YYYY-MM-DD') ||
                        ''
                      }
                      onChange={e =>
                        handleInputChange(d._id, 'endDate', e.target.value)
                      }
                      type="date"
                    />
                  </InputGroup>
                  <InputGroup size={'sm'}>
                    <InputLeftAddon fontSize={'.8em'}>
                      <i className="icons icon-clock" />{' '}
                    </InputLeftAddon>
                    <input
                      style={{
                        fontSize: '.8em',
                        padding: '0.2em 0.5em',
                        border: '1px solid #E2E8F0'
                      }}
                      textAlign={'right'}
                      value={
                        formValues[d._id]?.startDate ||
                        dayjs(d?.startDate)?.format('YYYY-MM-DD')
                      }
                      onChange={e =>
                        handleInputChange(d._id, 'startDate', e.target.value)
                      }
                      type="date"
                    />
                  </InputGroup>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  <Paper elevation={3} className="historyItem">
                    <Text fontSize={'1em'} fontWeight={'bold'}>
                      {thisTitle}
                    </Text>
                    {(type === 'user' ||
                      type === 'resource' ||
                      type === 'project') && (
                      <Text
                        className="removeHistory"
                        onClick={() => setDeleteId(d._id)}
                      >
                        Remove
                      </Text>
                    )}
                    {/* <Text fontSize={'.7em'}>Because you need strength</Text> */}
                  </Paper>
                  <Button
                    size={'sm'}
                    width={'100%'}
                    variant="outline"
                    fontSize={'.8em'}
                    onClick={() => updateHistory(d._id)}
                  >
                    Atualizar
                  </Button>
                </TimelineContent>
              </TimelineItem>
            )
          })}

      <AlertDialog
        motionPreset="slideInBottom"
        onClose={() => setDeleteId(null)}
        isOpen={deleteId}
        isCentered
      >
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader>Delete relation?</AlertDialogHeader>
          <AlertDialogCloseButton />

          <AlertDialogFooter>
            <Button onClick={() => setDeleteId(null)}>No</Button>
            <Button
              colorScheme="red"
              ml={3}
              onClick={() => {
                if (type === 'user') {
                  setRemoteCall('delRelation', { _id: deleteId })
                  setRemoteCall('getUserHistory', props.id)
                } else if (type === 'resource') {
                  setRemoteCall('delRelation', { _id: deleteId })
                  setRemoteCall('getResourceHistory', props.id)
                } else if (type === 'project') {
                  setRemoteCall('delRelation', { _id: deleteId })
                  setRemoteCall('getProjectHistory', props.id)
                }
                setDeleteId(null)
              }}
            >
              Yes
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Timeline>
  )
}
